var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDownGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37px",
    height: "45px",
    viewBox: "0 0 37 45",
    enableBackground: "new 0 0 37 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 37,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#C6C6C6",
    points: "36.219,28.773 31.68,24.238 26.469,29.449 21.258,24.238  16.719,28.773 21.93,33.988 16.719,39.199 21.258,43.738 26.469,38.527 31.68,43.738 36.219,39.199 31.008,33.988  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 37,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#C6C6C6",
    d: "M32.316,5.352L31.117,0C17.273,3.109,6.57,14.18,4.301,27.59 c-1.254-0.438-2.43-1.082-3.449-1.969c-0.176-0.145-0.418-0.16-0.614-0.043c-0.191,0.117-0.277,0.352-0.218,0.57l5.058,18.473 C5.137,44.832,5.316,44.977,5.531,45c0.016,0,0.028,0,0.043,0c0.203,0,0.379-0.117,0.469-0.301l8.117-17.355 c0.098-0.207,0.047-0.449-0.125-0.602c-0.16-0.145-0.406-0.168-0.605-0.059c-1.106,0.658-2.328,1.039-3.586,1.271 C11.941,16.969,20.832,7.941,32.316,5.352"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDownGrau);
export default __webpack_public_path__ + "static/media/noDown_Grau.b7d795dded61d7f85a7e4b07de37dfc1.svg";
export { ForwardRef as ReactComponent };